export default __webpack_public_path__ + "static/play-agent3-bop-hindi-51d7e7d791f9de892e90ddd354455ad8.png";